"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportSettingsResponseDto = void 0;
const export_settings_update_dto_1 = require("./export-settings-update.dto");
class ExportSettingsResponseDto extends export_settings_update_dto_1.ExportSettingsUpdateDto {
    getFields() {
        const fields = super.getFields();
        return [...fields];
    }
    mapFields(source) {
        super.mapFields(source);
        this.additionalRuntimes = !source['additionalRuntimes'] ? [] : source['additionalRuntimes'].map((runtime) => runtime.runtime);
        return this;
    }
}
exports.ExportSettingsResponseDto = ExportSettingsResponseDto;
